import React from 'react';
import styles from './Frontpage.module.css';
import Dancinggraph from './Dancinggraph';
import Text from './Text';
import Slidingpart from './Slidingpart';
import Navbar from './Navbar';
const Frontpage = (props)=>{

   return (
      
      <div>   
          <Navbar/>
       <div className={styles.first}>
         <div className={styles.container}>
            <Text />
            <Dancinggraph />
         </div>
       </div>
       <div className={styles.next}>
       <Slidingpart ></Slidingpart>
       </div>
       </div>
     
   );
};

export default Frontpage;